
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'
import isEmpty from 'lodash/isEmpty'

import { tw } from '@core/tailwind'

export default {
  components: {
    RevIllustration,
    RevTag,
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: '',
    },
    counterOfferPrice: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasImage() {
      return !isEmpty(this.image)
    },
    hasCounterOfferPrice() {
      return !isEmpty(this.counterOfferPrice)
    },
    hasTag() {
      return !isEmpty(this.tag)
    },
    priceClasses() {
      return this.hasCounterOfferPrice
        ? tw`body-3-light-striked text-primary-light ml-1`
        : tw`body-2-bold text-primary-light`
    },
  },
}
